import { memo } from 'react'
import { useWireState } from '@forminator/react-wire'
import * as store from '@store'

import Dialog from '@components/shared/Dialogs/Dialog'
import cn from 'clsx'

const AddExistingOrgMemberDialog = ({
    className,
    newMemberEmail,
    loadingAddMember,
    onAddMemberClick,
    onChange,
}) => {
    
    const [open, setOpen] = useWireState(store.addExistingOrgMemberDialogOpen)
    
    return (
        
        <Dialog
            className={cn('AddExistingOrgMemberDialog relative', className)}
            panelClassName="max-w-screen-sm scale-y-95 modal-content"
            panelProps={{}}
            open={open}
            setOpen={setOpen}
            modal={false}
            title="Add Existing Member"
            subtitle={null}
            positiveText="Add Member"
            positiveLoading={loadingAddMember}
            positiveDisabled={loadingAddMember}
            onPositiveClick={onAddMemberClick}
            negativeText="Cancel"
            negativeDisabled={loadingAddMember}
            onNegativeClick={() => setOpen(false)}>
            
            <div className="flex flex-col mt-2 form-group">
                <input
                    className="input input-bordered w-full"
                    type="email"
                    value={newMemberEmail}
                    placeholder="someone@gmail.com"
                    autoComplete="email"
                    disabled={loadingAddMember}
                    onChange={onChange}/>
            </div>
        
        </Dialog>
        
    )
    
}

export default memo(AddExistingOrgMemberDialog)
